import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { connect } from "react-redux";
import { setGroupDragable, setDragOverGroup } from "Store/GridLayout/action";
import { DragSource, DropTarget } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import platform from "Pub/js/platform";
import { setGridDroppable } from "./utilService";
const { NCDiv } = platform.base;

const groupItemSource = {
    beginDrag(props) {
        setGridDroppable(false); //开始拖拽禁用GridLayout的droppable
        // props.setDragOverGroup(null); //重置分组高亮状态 提bug再放开
        return {
            id: props.group.pk_app_group,
            group: props.group,
            index: props.index,
            type: "group",
        };
    },
    canDrag(props) {
        return props.editable && props.groupCanDrag && props.currEditID === "";
    },
    endDrag(props) {
        setGridDroppable(true); //结束拖拽恢复GridLayout的droppable
        props.setGroupDragable(true); //恢复分组拖拽
    },
};

const groupItemTarget = {
    hover(props, monitor, component) {
        const dragItem = monitor.getItem();

        if (dragItem.type === "group") {
            //组hover到组
            const dragIndex = monitor.getItem().index;
            const hoverIndex = props.index;

            if (dragIndex === hoverIndex) {
                return;
            }

            const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

            const clientOffset = monitor.getClientOffset();

            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            props.moveGroupItem(dragIndex, hoverIndex);

            monitor.getItem().index = hoverIndex;
        }
    },
    drop(props, monitor) {
        const dragItem = monitor.getItem();
        if (dragItem.type === "group") {
            //释放的分组对象
            props.moveGroupItem(dragItem.index, props.index);
        }
    },
};

//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget("item", groupItemTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
//DropSource用于包装你需要拖动的组件，使组件能够被拖拽
@DragSource("item", groupItemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
}))
class GroupItem extends Component {
    componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview(getEmptyImage(), {
            // IE fallback: specify that we'd rather screenshot the node
            // when it already knows it's being dragged so we can hide it with CSS.
            captureDraggingState: true,
        });
    }

    render() {
        const {
            isDragging,
            connectDragSource,
            connectDropTarget,
            id,
            currEditID,
            editable,
            group,
            index
        } = this.props;
        const opacity = isDragging ? 0 : 1;
        const groupDrag = currEditID === id ? "groupDragID" : "";
        return (
            <NCDiv style={{ height: '100%' }} fieldid={group.groupname} areaCode={NCDiv.config.Group}>
                {/* 工作台没有分组  不需要拖拽 */}
                {/* {connectDragSource(
                    connectDropTarget( */}
                <div
                    className="nc-workbench-app-container"
                    style={{ opacity }}
                    id={groupDrag}
                >
                    {editable ? (
                        this.props.header
                    ) : (
                        null
                        // <div className="title" style={index === 0 ? { display: 'none'} : {}}>{group.groupname}</div>
                    )}
                    {this.props.content}
                    {/* {this.renderAddBtn()} */}
                </div>
                {/* ) */}
                {/* )} */}
            </NCDiv>
        );
    }
}

export default connect(
    (state) => ({
        currEditID: state.gridLayoutData.currEditID,
        editable: state.gridLayoutData.editable,
        groupCanDrag: state.gridLayoutData.groupCanDrag,
    }),
    {
        setGroupDragable,
        setDragOverGroup
    }
)(GroupItem);
